
var April = April || {};

(function(){

  April.codes = {};

  April.define = function(key, func){
    April.codes[key] = func;
  };

  April.call = function(key, args){
    if(!April.codes[key]){
      // console.error('April not found :'+key);
    }
    return April.codes[key](args);
  };

})();

module.exports = April;